<template>
  <b-sidebar
    id="sidebar"
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-backdrop
    right
    @shown="loadData"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0 text-capitalize">
          {{
            (isAdd ? $t("actions.add") : $t("actions.edit")) +
            " " +
            $tc("dmp.profile", 1)
          }}
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="description"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('dmp.name')"
              label-for="description"
            >
              <b-form-input
                id="description"
                v-model="itemData.name"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Panel Model -->
          <validation-provider
            #default="validationContext"
            name="panel_model"
            rules="required"
          >
            <b-form-group
              class="text-capitalize"
              :label="$t('dmp.panel_model')"
              label-for="event"
            >
              <v-select
                label="panel_model"
                v-model="itemData.panel_model"
                :options="panelModelOptions"
                :clearable="true"
                input-id="panel_model"

              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- devices -->
 <!--          <validation-provider
             v-if="itemData.panel_model"
             #default="validationContext"
             name="devices_profile"

          >
            <b-form-group
              class="text-capitalize"
              :label="$t('dmp.devices')"
              label-for="devices"
            >
              <div class="accordion mb-2" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header
                    header-tag="header"
                    class="p-1"
                    role="tab button"
                  >
                    <p class="mb-0 d-flex align-items-center justify-content-center w-100" v-b-toggle.accordion-pgms role="button">
                      PGMS
                      <b-badge class="ml-1" variant="primary">
                        {{ devicesPgmSelected }} / {{ pgmsDevices }}
                      </b-badge>
                    </p>
                  </b-card-header>
                  <b-collapse
                    id="accordion-pgms"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        v-for="pgm in devicesApi.pgms"
                        :key="pgm.name"
                        class="mb-1"
                      >
                        <div class="border rounded p-1">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            {{ pgm.name }}
                            <b-form-checkbox
                              v-model="itemData.devices_profile"
                              switch
                              :value="pgm"
                              :disabled="!pgm.alias"
                            >
                            </b-form-checkbox>
                          </div>
                          <b-form-group
                            class="text-capitalize"
                            :label="$t('dmp.alias')"
                            label-for="alias"
                          >
                            <b-form-input
                              id="alias"
                              v-model="pgm.alias"
                              trim
                              @input="checkAlias($event, pgm)"
                            />
                          </b-form-group>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header
                    header-tag="header"
                    class="p-1"
                    role="tab button"
                  >
                    <p class="mb-0 d-flex align-items-center justify-content-center w-100" v-b-toggle.accordion-zones role="button">
                      Zones
                      <b-badge class="ml-1" variant="primary">
                        {{ devicesZonesSelected }} /  {{ zonesDevices }}
                      </b-badge>
                    </p>
                  </b-card-header>
                  <b-collapse
                    id="accordion-zones"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        v-for="zone in devicesApi.zones"
                        :key="zone.name"
                        class="my-1"
                      >
                        <div class="border rounded p-1">
                          <div class="d-flex justify-content-between align-items-center">
                            {{ zone.name }}
                            <b-form-checkbox
                              v-model="itemData.devices_profile"
                              switch
                              :value="zone"
                              :disabled="!zone.alias"
                            >
                            </b-form-checkbox>
                          </div>
                          <b-form-group
                            class="text-capitalize mb-0"
                            :label="$t('dmp.alias')"
                            label-for="alias"
                          >
                            <b-form-input
                              id="alias"
                              v-model="zone.alias"
                              trim
                            />
                          </b-form-group>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 text-capitalize"
              type="submit"
            >
              {{ isAdd ? $t("actions.add") : $t("actions.edit") }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="text-capitalize"
            >
              {{ $t("actions.cancel") }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { computed, ref, onMounted } from "@vue/composition-api";
import { required, alphaNum, email, positive, required_if } from "@validations";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import store from "@/store";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BInputGroupAppend,
    BButton,
    vSelect,
    BFormCheckbox,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isSidebarActive",
    event: "update:is-sidebar-active",
  },
  props: {
    idPanel: {
      type: String | Number,
    },
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    itemEdit: {
      type: Object,
      required: false,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    panelModelOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      positive,
    };
  },
  setup(props, { emit }) {
    //COMPOSABLES
    const toast = useToast();

    //DATA
    const blankData = {
      name: parseInt(props.idPanel),
      panel_model: null,
      devices_profile: []
    };

    const devicesApi = ref({
      pgms: [],
      zones: []
    });

    const itemData = ref(JSON.parse(JSON.stringify(blankData)));

    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankData));
    };

    //Computed
    const devicesPgmSelected = computed(() => {
      let pgmDevices = itemData.value.devices_profile.filter(d => d.type === 'pgms');

      return pgmDevices.length;
    });

    const devicesZonesSelected = computed(() => {
      let zonesDevices = itemData.value.devices_profile.filter(d => d.type === 'zones');

      return zonesDevices.length;
    });

    const pgmsDevices = computed(() => {
      let pgmsLength = devicesApi.value.pgms.length;

      return pgmsLength;
    });

    const zonesDevices = computed(() => {
      let zonesLength = devicesApi.value.zones.length;

      return zonesLength;
    });

    //Methods
    const checkAlias = (value, device) => {
      let { name } = device;

      if (!value) {
        let indexDevice = itemData.value.devices_profile.findIndex(deviceProfile => deviceProfile.name == name);

        if (indexDevice !== -1) {
          itemData.value.devices_profile.splice(indexDevice, 1);
        }
      }
    }

    const setDevices = (data) => {
      let { devices,panel_model }  = data;
      let types       = devices.map(device => device.type);
      let devicesType = [...new Set(types)];

      itemData.value.panel_model = panel_model;

      for (const type of devicesType) {
        let devicesFilter = devices.filter(device => device.type === type);

        devicesApi.value[type] = [];

        for (const deviceApi of devicesFilter) {
          let [index] = deviceApi.name.match(/\d+/);

          devicesApi.value[type].push({
            name: deviceApi.name,
            alias: '',
            type,
            index: index
          });
        }

      }
    }

    const onSubmit = async () => {
      let dispatch;
     /*  itemData.value.devices_profile.forEach(device => {
          delete device.type;
      }); */

      if (props.isAdd) {
        dispatch = store.dispatch("dmp_profiles/add", itemData.value);
      } else {
        const req = {
          id: itemData.value.id,
          params: itemData.value,
        };
        dispatch = store.dispatch("dmp_profiles/edit", req);
      }

      dispatch
        .then((response) => {
          if (response.success) {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "CheckIcon",
                variant: "success",
              },
            });

            emit("refetch-data");
            emit("update:is-sidebar-active", false);
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: response.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((response) => {
          toast({
            component: ToastificationContent,
            props: {
              title: response.response.data.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const { refFormObserver, getValidationState, resetForm } = formValidation(resetData);

    const loadData = () => {
      if (!props.isAdd) {
        itemData.value = props.itemEdit;
      }
    };

    return {
      itemData,
      onSubmit,

      refFormObserver,
      getValidationState,
      loadData,
      resetForm,

      devicesApi,

      devicesPgmSelected,
      devicesZonesSelected,
      pgmsDevices,
      zonesDevices,

      checkAlias,
      setDevices
    };
  },
};
</script>
